/*!
 * AGL DLS Components built with Stencil
 */
import { h } from '@stencil/core';
export function getHintText(hintText, componentId) {
  return (hintText && (h("span", { class: "hint-text", id: 'hint-text-' + componentId }, hintText)));
}
export function getAlertText(errorText, successText, invalid, componentId) {
  let alertText;
  if (!invalid && successText) {
    alertText = successText;
  }
  else if (invalid && errorText) {
    alertText = errorText;
  }
  let icon;
  let iconAltText;
  if (invalid !== undefined && alertText) {
    icon = getIcon(invalid);
    iconAltText = icon.substring(icon.indexOf('-') + 1, icon.length);
  }
  return (invalid !== undefined &&
    alertText && (h("div", { class: "alert-text-container", id: 'alert-text-' + componentId },
    h("dls-functional-icon", { padding: "right", altText: iconAltText, type: icon, size: "sm" }),
    h("span", { class: { [`alert-text--error`]: invalid, [`alert-text--success`]: !invalid } }, alertText))));
}
function getIcon(invalid) {
  let iconType = 'notification-error';
  if (!invalid) {
    iconType = 'notification-success';
  }
  return iconType;
}
export function getLabelText(label, hintText, componentId) {
  return (label && (h("legend", null,
    label,
    getHintText(hintText, componentId))));
}
